var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ImagePlugin as BasePlugin } from '@syllepsis/plugin-basic';
import { ImageView, InlineImageView } from './view';
var ImagePlugin = /** @class */ (function (_super) {
    __extends(ImagePlugin, _super);
    function ImagePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Schema = ImageView;
        return _this;
    }
    return ImagePlugin;
}(BasePlugin));
var InlineImagePlugin = /** @class */ (function (_super) {
    __extends(InlineImagePlugin, _super);
    function InlineImagePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.Schema = InlineImageView;
        return _this;
    }
    return InlineImagePlugin;
}(BasePlugin));
export { ImagePlugin, InlineImagePlugin };
//# sourceMappingURL=index.js.map